import { render } from "./App.vue?vue&type=template&id=ed1ec6dc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=ed1ec6dc&lang=css"

import exportComponent from "/Users/xiaochenzhang/WebstormProjects/pss-work-weixin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__